/** Unlink readback projects the existing run and verified privacy receipt; a hold is never completion. */
import * as z from 'zod';
export const shopifyConnectionCleanupSchema = z.strictObject({
    requestId: z.string().min(1),
    runId: z.string().min(1),
    status: z.enum(['pending', 'failed', 'completed']),
    /** The existing obligation can still be dispatched; terminal runs need support, not a no-op Retry button. */
    canRetry: z.boolean(),
    error: z.string().nullable(),
});
export const shopifyConnectionCleanupResponseSchema = z.strictObject({
    organizationId: z.string().min(1),
    connectionId: z.string().min(1),
    cleanup: shopifyConnectionCleanupSchema.nullable(),
});
//# sourceMappingURL=shopify-connection-unlink.js.map